import { render } from "./LogisticsPage.vue?vue&type=template&id=87dd6928"
import script from "./LogisticsPage.vue?vue&type=script&lang=js"
export * from "./LogisticsPage.vue?vue&type=script&lang=js"

import "./LogisticsPage.vue?vue&type=style&index=0&id=87dd6928&lang=css"

import exportComponent from "/home/ubuntu/apps/crm/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__